(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["athar-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.athar-policy-menu[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.athar-policy-menu[open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["athar-product"] && !Shopify.designMode) return;
  try {
    
  function initializeAtharModels() {
    if (!document.querySelector('.athar-product__model') || !window.Shopify?.loadFeatures) return;
    Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: (error) => {
      if (error) return;
      document.querySelectorAll('.athar-product__model').forEach((model) => {
        if (!model.dataset.initialized) {
          new Shopify.ModelViewerUI(model);
          model.dataset.initialized = 'true';
        }
      });
    } }]);
  }
  initializeAtharModels();
  document.addEventListener('shopify:section:load', initializeAtharModels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
